import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  Input,
  Label,
  FormGroup,
} from "reactstrap";
import {
  createMenu,
  createMenuMult,
} from "redux/actions/Screening/screeningActions";
import { connect } from "react-redux";

const Cadastrar = (props) => {
  // ** Const
  // ** Props
  const { open, setOpen, nameDefault } = props;
  const [menu, setMenu] = useState({
    nome: "",
    menu: "",
    emails: "",
    grupos: "",
    confidencial: false,
    habilita_arquivo_local: false,
    diretorio_local: "P:\\sistemas\\reports",
    ordem: 1,
  });

  useEffect(() => {
    if (props.menu) {
      window.location.href = `/admin/${
        props.menu.area
      }/${props.menu.menu.replace(/\|/g, "/")}/${props.menu.id}`;
      //window.location.reload()
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.menu]);

  useEffect(() => {
    if (nameDefault)
      setMenu({
        ...menu,
        menu: localStorage.getItem("menu_completo")?.replace(/\//g, "|"),
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nameDefault, localStorage.getItem("menu_completo")]);

  const handleSubmit = (e) => {
    e.preventDefault();
    let area = localStorage.getItem("area");
    menu.area = area;

    // if (menus.length > 1) {
    //   let menuName = "";
    //   menus.forEach((element, index) => {
    //     const name = element.trimStart().trimEnd();
    //     if (index === 0) {
    //       menuName = name;
    //       const exist = props.existMenu(name, area);
    //       if (!exist) {
    //         menu.menu = menuName;
    //         menusToAdd.push({
    //           params: {
    //             arg1: area,
    //             arg2: name,
    //             arg3: menu.emails,
    //             arg4: menu.grupos || "",
    //             arg5: menu.confidencial || false,
    //             arg6: menu.principal || false,
    //             arg7: props.getListMenus(menu).length + 1,
    //             arg8: menu.habilita_arquivo_local,
    //             arg9: menu.diretorio_local,
    //           },
    //         });
    //       }
    //     } else {
    //       menuName = `${menuName} | ${name}`;
    //       if (!props.existMenu(menuName, area)) {
    //         menu.menu = menuName;
    //         menusToAdd.push({
    //           params: {
    //             arg1: area,
    //             arg2: menuName,
    //             arg3: menu.emails,
    //             arg4: menu.grupos || "",
    //             arg5: menu.confidencial || false,
    //             arg6: menu.principal || false,
    //             arg7: props.getListMenus(menu).length + 1,
    //             arg8: menu.habilita_arquivo_local,
    //             arg9: menu.diretorio_local,
    //           },
    //         });
    //       }
    //     }
    //   });
    //   if (menusToAdd.length === 1) props.createMenu(menusToAdd[0]);
    //   else props.createMenuMult(menusToAdd);
    // } else {
    let model = {
      params: {
        arg1: area,
        arg2: menu.menu,
        arg3: menu.emails,
        arg4: menu.grupos || "",
        arg5: menu.confidencial || false,
        arg6: menu.principal || false,
        arg8: menu.habilita_arquivo_local,
        arg9: menu.diretorio_local,
      },
    };
    props.createMenu(model);
    //}
    setOpen(false);
  };

  return (
    <Modal
      isOpen={open}
      toggle={() => setOpen(!open)}
      className={`modal-dialog-centered`}
      size="lg"
    >
      <ModalHeader toggle={() => setOpen(!open)}>Cadastrar Menu </ModalHeader>
      <ModalBody>
        <Form id="form" className="mb-2">
          <FormGroup>
            <Label for="nome">
              Menu{" "}
              <span style={{ fontSize: 11 }}>
                *(Para criar sub menus separar pelo caracter "|")
              </span>
            </Label>
            <Input
              type="text"
              id="name"
              placeholder="Menu 1 | submenu 1"
              value={menu.menu}
              name="menu"
              disabled={nameDefault}
              onChange={(e) =>
                setMenu({
                  ...menu,
                  [e.target.name]: e.target.value,
                })
              }
            />
          </FormGroup>
          <FormGroup>
            <Label for="nome">
              Emails com acesso{" "}
              <span style={{ fontSize: 11 }}>*(separados por vírgula)</span>
            </Label>
            <Input
              type="textarea"
              id="name"
              placeholder="Emails com acesso"
              value={menu.name}
              name="name"
              onChange={(e) =>
                setMenu({
                  ...menu,
                  emails: e.target.value,
                })
              }
            />
          </FormGroup>
          <FormGroup>
            <Label for="nome">
              Grupos com acesso{" "}
              <span style={{ fontSize: 11 }}>*(separados por vírgula)</span>
            </Label>
            <Input
              type="text"
              id="name"
              placeholder="Grupos com acesso"
              value={menu.name}
              name="name"
              onChange={(e) =>
                setMenu({
                  ...menu,
                  grupos: e.target.value,
                })
              }
            />
          </FormGroup>
          <FormGroup className="ml-4 mt-3">
            <Label>
              <Input
                type="checkbox"
                checked={menu.confidencial}
                onChange={(e) =>
                  setMenu({
                    ...menu,
                    confidencial: !menu.confidencial,
                  })
                }
              />
              Intranet{" "}
              <span style={{ fontSize: 11 }}>
                *(acesso somente pelo escritorio)
              </span>{" "}
            </Label>
          </FormGroup>
          <FormGroup className="ml-4 mt-3">
            <Label>
              <Input
                type="checkbox"
                checked={menu.habilita_arquivo_local}
                onChange={(e) =>
                  setMenu({
                    ...menu,
                    habilita_arquivo_local: !menu.habilita_arquivo_local,
                  })
                }
              />
              Salvar em pasta local{" "}
            </Label>
          </FormGroup>
          {menu.habilita_arquivo_local ? (
            <FormGroup>
              <Label for="nome">
                Diretório raiz
                <span style={{ fontSize: 11 }}>
                  *(Diretório raiz onde será salvo os arquivos das abas desse
                  menu)
                </span>
              </Label>
              <Input
                type="text"
                id="name"
                placeholder="Diretório raiz"
                value={menu.diretorio_local}
                name="name"
                onChange={(e) =>
                  setMenu({
                    ...menu,
                    diretorio_local: e.target.value,
                  })
                }
              />
            </FormGroup>
          ) : null}
          <FormGroup className="ml-4 mt-3">
            <Label>
              <Input
                type="checkbox"
                checked={menu.principal}
                onChange={(e) =>
                  setMenu({
                    ...menu,
                    principal: !menu.principal,
                  })
                }
              />
              Menu Principal{" "}
              <span style={{ fontSize: 11 }}>
                *(menu que aparecerar primeiro quando escolher a area{" "}
                {localStorage.getItem("area")})
              </span>{" "}
            </Label>
          </FormGroup>
          {/* <FormGroup>
            <Label for="ordem">Ordem</Label>
            <Input
              type="number"
              min={1}
              id="ordem"
              placeholder="Ordenação no Menu"
              value={menu.ordem}
              name="ordem"
              onChange={(e) => {
                const value = e.target.value < 1 || e.target.value > props.maxSize ? menu.ordem : e.target.value
                setMenu({
                  ...menu,
                  [e.target.name]: value,
                })
              }}
            />
          </FormGroup> */}
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button type="submit" onClick={(e) => handleSubmit(e)} color="primary">
          Cadastrar
        </Button>
      </ModalFooter>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  return {
    publish: state.screening.screening.publish,
    menuNew: state.screening.screening.menuNew,
    editMenu: state.screening.screening.editMenu,
    menu: state.screening.screening.menu,
    //e/rror: state.screening.screening.error,
    //loading: state.screening.screening.loading,
  };
};

export default connect(mapStateToProps, {
  createMenu,
  createMenuMult,
})(Cadastrar);
